module.exports = __webpack_public_path__ + "02_veryshort_black.228e0cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_veryshort_black.png
// module id = q37f
// module chunks = 0